import { sortSections } from './model.ts';
import type { SettingsSection } from './model.ts';

export { SETTINGS_ALIASES, SETTINGS_GROUPS, filterSections, groupSections, sortSections } from './model.ts';
export type { SettingsGroup, SettingsSection } from './model.ts';

const modules = import.meta.glob<{ default: SettingsSection }>('./sections/*.tsx', { eager: true });

export const SETTINGS_SECTIONS: SettingsSection[] = sortSections(
  Object.values(modules)
    .map((m) => m.default)
    .filter(Boolean),
);

